function NotFound() {
  return (
    <div>
      <h2>NotFound</h2>
    </div>
  );
}

export default NotFound;
